import { Stack, SxProps, Theme, Typography } from '@mui/material';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';

interface ForumMessagePreviewTagProps {
  title: string;
  sx?: SxProps<Theme>;
}

const ForumMessagePreviewTag = ({ title, sx }: ForumMessagePreviewTagProps) => (
  <Stack
    direction="row"
    p={1}
    spacing={1}
    sx={{
      backgroundColor: 'feedback.chatBubble.primary',
      borderBottomRightRadius: 8,
      borderTopLeftRadius: 8,
      ...sx,
    }}
    width={220}
    mb={-1}
    alignItems="center"
  >
    <PlaylistAddCheckIcon />
    <Typography variant="subtitle1">{title}</Typography>
  </Stack>
);

export default ForumMessagePreviewTag;
